import Home from '@/pages/Home.vue';
import SignUp from '@/pages/SignUp.vue';
import Questions from '@/pages/Questions.vue';
import SignUpComplete from '@/pages/SignupComplete.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Orbit Pathfinder'
    }
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
    meta: {
      title: 'Orbit Pathfinder'
    }
  },
  {
    path: '/questionairies',
    name: 'Question',
    component: Questions,
    meta: {
      title: 'Orbit Pathfinder'
    }
  },
  {
    path: '/complete',
    name: 'SignUpComplete',
    component: SignUpComplete,
    meta: {
      title: 'Orbit Pathfinder'
    }
  },
];

export default routes;